import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function VisioDiagnostic() {
  return (
    <section className="bg-[#F5F2EB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="w-full lg:w-1/2">
            <div className="rounded-xl overflow-hidden h-[300px] md:h-[400px]">
              <ImagePlaceholder
                src="https://readdy.ai/api/search-image?query=Professional%20technician%20smiling%20while%20on%20a%20video%20call%20with%20a%20homeowner%20on%20a%20smartphone%20screen%2C%20showing%20a%20roller%20shutter%20problem%20during%20a%20virtual%20consultation%2C%20modern%20clean%20workspace%20with%20laptop%20and%20tools%2C%20warm%20lighting%2C%20professional%20and%20friendly%20atmosphere%2C%20realistic%20photography%20style%2C%20clean%20background%20with%20soft%20natural%20colors&width=800&height=600&seq=visio1&orientation=landscape"
                alt="Visio-diagnostic gratuit de volet roulant par un technicien professionnel"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <div className="inline-flex items-center gap-2 bg-[#E8734A]/10 text-[#E8734A] px-4 py-1.5 rounded-full text-sm font-semibold mb-4">
              <i className="ri-video-chat-line"></i>
              Nouveau — 100% gratuit
            </div>
            <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold mb-4 leading-tight">
              Visio-diagnostic gratuit de votre volet roulant
            </h2>
            <p className="text-[#2F4A63] text-base md:text-lg leading-relaxed mb-6">
              Pas besoin de déplacement pour un premier diagnostic. En quelques minutes par visioconférence, notre technicien évalue la panne, vous oriente sur la solution et vous donne une estimation précise. Rapide, pratique et totalement gratuit.
            </p>

            <ul className="space-y-3 mb-8">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#E8734A]/10 shrink-0 mt-0.5">
                  <i className="ri-check-line text-[#E8734A] text-sm"></i>
                </div>
                <p className="text-[#2F4A63] text-sm md:text-base">
                  Diagnostic rapide en 5 à 10 minutes par visioconférence
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#E8734A]/10 shrink-0 mt-0.5">
                  <i className="ri-check-line text-[#E8734A] text-sm"></i>
                </div>
                <p className="text-[#2F4A63] text-sm md:text-base">
                  Évaluation précise de la panne sans déplacement initial
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#E8734A]/10 shrink-0 mt-0.5">
                  <i className="ri-check-line text-[#E8734A] text-sm"></i>
                </div>
                <p className="text-[#2F4A63] text-sm md:text-base">
                  Devis chiffré transparent avant toute intervention
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#E8734A]/10 shrink-0 mt-0.5">
                  <i className="ri-check-line text-[#E8734A] text-sm"></i>
                </div>
                <p className="text-[#2F4A63] text-sm md:text-base">
                  Service 100% gratuit, sans engagement
                </p>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="tel:0374473240"
                className="inline-flex items-center justify-center gap-2 bg-[#E8734A] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#E8734A]/90 transition-colors whitespace-nowrap"
              >
                <i className="ri-video-chat-line text-lg"></i>
                Prendre un rendez-vous visio
              </a>
              <a
                href="#devis"
                className="inline-flex items-center justify-center gap-2 bg-transparent border border-[#1B2A4A] text-[#1B2A4A] px-6 py-4 rounded-full font-semibold text-base hover:bg-[#1B2A4A]/5 transition-colors whitespace-nowrap"
              >
                Demander un devis
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}